<div class="login-container">
  <div class="content" geneaLoadingIndicator>


    <div class="g-header text-center">
      <span alt="GENEA" class="geneaLogo" ></span>
    </div>

    @if (currentStep() === 'email') {
      <div class="align-self-center login-box">
        <h1 class="login-text">Log In</h1>
        <form [formGroup]="emailForm" (ngSubmit)="onNext()">
          <div class="col-12 field-group form-group p-0">
            <label class="field-label" for="email">Email</label>
            <div class="input-wrapper">
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control input-field emailIcon"
                placeholder="name@company.com"
              />
            </div>
          </div>
          <div class="login-button">
            <button
              type="submit"
              class="btn login-btn"
              [disabled]="emailForm.invalid || processing()"
            >
              {{ nextButtonText() }}
            </button>
          </div>
          <div class="legal-footer">
            By logging in you accept the Genea <a href="https://www.getgenea.com/terms-of-service/" target="_blank">Terms of Service</a> & <a href="https://www.getgenea.com/privacy-policy/" target="_blank">Privacy Policy</a>
          </div>
        </form>
      </div>
    }

    @if (currentStep() === 'password') {
      <div class="align-self-center login-box">
        <div class="user-info-header">
          <button type="button" class="back-button" (click)="onBack()" aria-label="Go back">
            <span class="back-arrow">&lsaquo;</span>
          </button>
          <div class="user-details">
            <span class="user-name">{{ emailForm.value.email }}</span>
          </div>
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="onLogin()">
          <div class="col-12 field-group form-group p-0">
            <label class="field-label" for="password">Password</label>
            <div class="input-wrapper">
              <input
                type="password"
                id="password"
                name="password"
                class="form-control input-field lockIcon"
                (input)="onPasswordAutofill($event)"
                (keydown.enter)="onLogin()"
                autocomplete="current-password"
                spellcheck="false"
              />
            </div>
            <div class="forgot-password-row">
              <a class="forgot-password-link" (click)="onForgotPassword()">Forgot password</a>
            </div>
          </div>
          <div class="login-button">
            <button
              type="submit"
              class="btn login-btn"
              [disabled]="passwordForm.invalid || processing()"
            >
              {{ loginButtonText() }}
            </button>
          </div>
        </form>
      </div>
    }

    <div class="login-message-container">
      <div class="col-md-12">
        <span class="text-left btn-link"> <span class="phoneIcon"></span><a href="tel:+1-866-935-1557" class="reset">866-935-1557 </a></span>
        <span class="float-right btn-link"><span class="mailIcon"></span> <a href="mailto:support@getgenea.com" class="reset">{{'Support@GetGenea.com'}} </a></span>
      </div>
    </div>
  </div>

</div>
